<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        We need some more information from you
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Answer Now
        </v-btn>
      </template>
      <v-card
        ><div>
          Question # {{ questionsindex + 1 }} of {{ this.questions.length }}
          <component
            :is="this.questions[this.questionsindex].fieldType"
            v-bind="this.questions[this.questionsindex]"
          ></component>
          <v-progress-linear :value="progressbarvalue"></v-progress-linear>
          <v-btn v-if="this.questionsindex != 0" @click="BackButton()"
            >Back</v-btn
          >
          <v-btn
            v-if="this.questionsindex != this.questions.length - 1"
            @click="nextButton()"
            >Next</v-btn
          >
        </div></v-card
      >
    </v-dialog>
  </v-row>
</template>
<script>
import textInput from "./formQuestionTypes/textInput";
import selectList from "./formQuestionTypes/selectList.vue";
import selectRadio from "./formQuestionTypes/selectRadio.vue";

export default {
  components: {
    textInput,
    selectList,
    selectRadio
  },
  computed: {
    progressbarvalue: function() {
      return ((this.questionsindex + 1) / this.questions.length) * 100;
    }
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      questionsindex: 0,
      questions: [
        {
          fieldType: "selectRadio",
          query: "How are you feeling today?",
          name: "feelingtoday",
          options: ["Great", "Okay", "Not Good", "Terrible"]
        },
        {
          fieldType: "selectList",
          name: "title",
          multi: false,
          query: "What is your title?",
          options: ["Ms", "Mr", "Dr", "Lord"]
        },
        {
          fieldType: "textInput",
          query: "What is your first name?",
          name: "firstName"
        },
        {
          fieldType: "textInput",
          query: "What is your last name?",
          name: "lastName"
        }
      ]
    };
  },
  methods: {
    nextButton() {
      this.questionsindex++;
    },
    BackButton() {
      this.questionsindex--;
    }
  }
};
</script>
